import BackHeader from "components/header/BackHeader";
import Header from "components/header/Header";
import React, {useEffect, useState} from "react";
import {getParameter, openPopup, pageLoadingEvent} from "utils/commonUtil";
import {useNavigate} from "react-router-dom";
import {ReactComponent as CenterSafety} from 'assets/icon/centerSafety.svg';
import {ReactComponent as CenterObserve} from 'assets/icon/centerObserve.svg';
import Terms1 from "components/popup/Terms1";
import Terms2 from "components/popup/Terms2";
import {useGetRentMachineApi} from "../../../hooks/centerHooks";
import PageNavigator from "../../../components/pageNav/PageNavigator";
import {useCookies} from "react-cookie";
import noImage2 from 'assets/image/trade/noSmallImage.svg';
import CenterPopup from "../../../components/popup/CenterPopup";

const TradeCenterSelect = () => {
  const [page, setPage] = useState(Number(getParameter("page")) || 1);
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [cookies] = useCookies(['authToken']);
  const navigate = useNavigate();
  const getCode = getParameter("code") || "";
  const getName = getParameter("name") || "";
  const getFile = getParameter("file") || "";
  const getCenter = sessionStorage.getItem("center") || "본점";
  const authToken = cookies.authToken;

  let searchData = {
    page: page,
    count: 8,
    rentSiteCode: getCenter,
    machineGroupCode: getCode
  }

  useGetRentMachineApi({setList, setTotalCount}, authToken, searchData);

  const urlEvent = (no, machine, name, price, format, standard) => {
    const userCheck = sessionStorage.getItem("userCheck");
    console.log(userCheck);

    if (userCheck === "A") {
      navigate(`/center/detail?no=${no}&machine=${machine}&name=${name}&price=${price}&format=${format}&standard=${standard}`);
    } else {
      openPopup("centerPopup");
    }
  }

  const boxResize = () => {
    let box = document.querySelectorAll(".imageBox");

    box.forEach((element) => {
      let height = element.offsetWidth;
      element.style.height = `${height}px`;
    });
  }

  // 화면이 리사이즈될 때마다 boxResize 함수 실행
  window.addEventListener('resize', boxResize);

  useEffect(() => {
    pageLoadingEvent();
    boxResize();
  }, []);

  return (
    <>
      <CenterPopup />
      <Terms1 />
      <Terms2 />
      <section id="tradeCenterItems" className="centerItems container bc-white">
        <Header />
        <div className='content homeContent scrollbar'>
          <BackHeader title='함평군 농업기계 임대 신청' />
          <div className="inner">
            <div className="centerListSubTitleBox d-flex f-column a-center j-center ta-left w-100 mt-30 mb-30">
              <p className="fs-32 fw-7 fc-black1 w-100">
                함평군 농업기계임대사업소
              </p>
              <p className="fs-32 fw-7 fc-black1 w-100">
                <span className="fc-green1">임대 장비를 선택</span>
                해주세요
              </p>
            </div>
            <div className="centerListBtnBox d-flex f-row a-center j-left w-100 mb-30">
              <button
                className="safetyBtn d-flex f-row a-center j-center bc-lightGray9 mr-15"
                onClick={() => openPopup("terms2Popup")}
              >
                <CenterSafety />
                <span className="fs-20 fw-6 fc-darkGray10 ml-5">
                안전수칙
              </span>
              </button>
              <button
                className="observedBtn d-flex f-row a-center j-center bc-lightGray9"
                onClick={() => openPopup("terms1Popup")}
              >
                <CenterObserve />
                <span className="fs-20 fw-6 fc-darkGray10 ml-5">
                준수사항
              </span>
              </button>
            </div>
            <article className="d-flex a-center j-left mb-25">
              <div className="categoryImageBox">
                {getFile !== "" &&
                  <img src={ `https://www.hampyeong.go.kr/aml/bbs/data/lend_shop/${getFile}` || noImage2} alt={getName} />
                }

              </div>
              <p className="fs-28 fw-7">{getName}</p>
            </article>
            <article className="itemList mb-25">
              {list.map((item, index) => {
                return (
                  <div
                    key={index} className="itemBox d-flex a-start j-between"
                    onClick={() => urlEvent(item.no, getName, item.name, item.rentPrice, item.format, item.standard)}
                  >
                    <div className="imageBox">
                      {item.imageFileName &&
                        <img src={ `https://www.hampyeong.go.kr/aml/bbs/data/lend_shop/${item.imageFileName}` || noImage2} alt={item.name} />
                      }
                    </div>
                    <div className="textBox fs-22">
                      <p className="fw-7 mb-5">장비그룹</p>
                      <p className="mb-5">{item.name}</p>
                      <p className="mb-5">{item.format}</p>
                      <p className="mb-5">{item.standard}</p>
                      <p className="mb-5">최대 임대 일수: 3일</p>
                      <p className="fw-5 fc-red1">임대료: {item.rentPrice.toLocaleString()}원(일 기준)</p>
                    </div>
                  </div>
                );
              })}
            </article>
            <PageNavigator totalItems={totalCount} currentPage={page} setCurrentPage={setPage} pageContentAmount={6} />
          </div>
        </div>
      </section>
    </>
  );
};

export default TradeCenterSelect;